import { Action } from 'redux';

import PaymentsInfoData from '../interfaces/PaymentsInfoData';
import ActionFetchPaymentsSuccess from '../interfaces/actions/ActionFetchPaymentsSuccess';

import * as Const from '../constants';

export const fetchPaymentsInit = (): Action => {
  return {
    type: Const.FETCH_PAYMENTS_INIT,
  };
};

export const fetchPaymentsPending = (): Action => {
  return {
    type: Const.FETCH_PAYMENTS_PENDING,
  };
};

export const fetchPaymentsSuccess = (payload: PaymentsInfoData): ActionFetchPaymentsSuccess => {
  return {
    type: Const.FETCH_PAYMENTS_SUCCESS,
    payload,
  };
};

export const fetchPaymentsFail = (): Action => {
  return {
    type: Const.FETCH_PAYMENTS_FAIL,
  };
};
